import { render, staticRenderFns } from "./ViewVideo.vue?vue&type=template&id=d331b0e4&"
import script from "./ViewVideo.vue?vue&type=script&lang=js&"
export * from "./ViewVideo.vue?vue&type=script&lang=js&"
import style0 from "./ViewVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports